import ReactGA from 'react-ga'

export function sendGAEvent(e){
  if(process.env.NODE_ENV === 'production') {
    ReactGA.event(e);
  }
}




// WEBPACK FOOTER //
// ./src/components/interactive/helper-functions.js